import { Moon, Sun, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme, type Theme } from "@/hooks/useTheme";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const themes: { value: Theme; label: string; icon: React.ComponentType<any> }[] = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Monitor },
];

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();

  // Show the resolved theme icon when system is selected
  const getDisplayIcon = () => {
    if (theme === "system") {
      return resolvedTheme === "dark" ? Moon : Sun;
    }
    const currentTheme = themes.find(t => t.value === theme);
    return currentTheme?.icon || Sun;
  };

  const CurrentIcon = getDisplayIcon();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative overflow-hidden transition-all duration-300 hover:scale-105 hover:bg-muted/80"
          aria-label="Toggle theme"
        >
          <CurrentIcon className="h-5 w-5 transition-transform duration-300" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {themes.map(({ value, label, icon: Icon }) => (
          <DropdownMenuItem
            key={value}
            onClick={() => setTheme(value)}
            className={`flex items-center gap-2 cursor-pointer transition-colors ${theme === value ? "bg-accent text-accent-foreground" : ""
              }`}
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
            {value === "system" && theme === "system" && (
              <span className="ml-auto text-xs text-muted-foreground">
                ({resolvedTheme})
              </span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}